__turbopack_context__.v({
  "calloutSection": "VU3Q5W_calloutSection",
  "contactModal": "VU3Q5W_contactModal",
  "footer": "VU3Q5W_footer",
  "header": "VU3Q5W_header",
  "pricingProducts": "VU3Q5W_pricingProducts",
  "pricingTopSection": "VU3Q5W_pricingTopSection",
  "pricingWhySection": "VU3Q5W_pricingWhySection",
  "root": "VU3Q5W_root",
  "serviceMessage": "VU3Q5W_serviceMessage",
});
